import {
    RequestIdWithWarning,
    RequestDays,
} from '../../components/utilities/Table/generalColumns/RequestIdWithWarning';
import { OfficeRequest } from '../../components/utilities/Table/generalColumns/RegionalRequest';
import { ClientIdentification } from '../../components/utilities/Table/generalColumns/ClientIdentification';
import { AmountRequest } from '../../components/utilities/Table/generalColumns/AmountRequest';
import { ExecutiveWithTooltip } from '../../components/utilities/Table/generalColumns/ExecutiveWithTooltip';
import { StatusWithTooltip } from '../../components/utilities/Table/generalColumns/StatusWithTooltip';
import { CausalRequest } from '../../components/utilities/Table/generalColumns/CausalRequest';
const commonColumns = [
    RequestIdWithWarning(),
    {
        Header: 'Fecha',
        accessor: 'created_at',
    },
    {
        Header: 'Producto',
        accessor: 'subproducto.label',
    },
    OfficeRequest,
    ClientIdentification,
    {
        Header: 'Cliente',
        accessor: 'persona.full_name',
        typeId: 'HeaderClient',
    },
    ExecutiveWithTooltip,
    AmountRequest,
    {
        Header: 'Plazo',
        accessor: 'plazo_solicitado',
    },
];
const requestsListStatus = [
    {
        id: 'bolsa_general_mesa_de_ayuda',
        label: 'BOLSA GENERAL',
        status: 25,
        responsable: false,
        offices: true,
        columns: (() => {
            const cols = [...commonColumns];
            cols.splice(1, 1, RequestDays('gestionsolicitud.fecha_creacion'));
            cols.splice(2, 0, {
                Header: 'Fecha creación',
                accessor: 'gestionsolicitud.fecha_creacion',
            });
            return cols;
        })(),

        buttonAction: [{ name: 'takeRequest' }],
        componentNoShowMenu: ['DocumentsCredit'],
    },
    {
        id: 'en_proceso_ejecutivo',
        label: 'EN PROCESO',
        status: 25,
        responsable: true,
        offices: true,
        columns: (() => {
            const cols = [...commonColumns];
            cols.splice(1, 1, RequestDays('gestionsolicitud.fecha_creacion'));
            cols.splice(2, 0, {
                Header: 'Fecha creación',
                accessor: 'gestionsolicitud.fecha_creacion',
            });
            return cols;
        })(),
    },
    {
        id: 'procesadas_ejecutivo',
        label: 'PROCESADAS',
        status: false,
        offices: true,
        nameColumnProcessed: [
            {
                name: 'estado_solicitud__gt',
                value: 25,
                operator: '%26',
            },
            {
                name: 'gestionsolicitud__usuario_precomite',
                value: 'user',
                operator: '|',
            },
            {
                name: 'gestionsolicitud__usuario_rechazo',
                value: 'user',
                operator: '|',
            },
            {
                name: 'gestionsolicitud__usuario_desistimiento',
                value: 'user',
                operator: '|',
            },
        ],
        responsable: false,
        columns: (() => {
            const cols = [...commonColumns];
            cols.splice(1, 1, RequestDays('gestionsolicitud.fecha_creacion'));
            cols.splice(2, 0, {
                Header: 'Fecha creación',
                accessor: 'gestionsolicitud.fecha_creacion',
            });
            cols.splice(10, 0, StatusWithTooltip);
            cols.splice(12, 0, CausalRequest);
            return cols;
        })(),
        buttonAction: [{ name: 'resumeStatusRequest' }],
        registrationLimit: 5, // limit for registration in list credits
    },
];

export default requestsListStatus;
